module.exports = function (Utils, Konva) {
    'use strict';
    function PointsLayer(peaks, stage, view, allowEditing, showLabels) {
        this._peaks = peaks;
        this._stage = stage;
        this._view = view;
        this._allowEditing = allowEditing;
        this._showLabels = showLabels;
        this._pointGroups = {};
        this._createLayer();
        this._registerEventHandlers();
    }
    PointsLayer.prototype._createLayer = function () {
        this._layer = new Konva.Layer();
        this._stage.add(this._layer);
    };
    PointsLayer.prototype._registerEventHandlers = function () {
        var self = this;
        this._peaks.on('points.add', function (points) {
            var frameStartTime = self._view.pixelsToTime(self._view.frameOffset);
            var frameEndTime = self._view.pixelsToTime(self._view.frameOffset + self._view.width);
            points.forEach(function (point) {
                if (point.isVisible(frameStartTime, frameEndTime)) {
                    self._addPointGroup(point);
                }
            });
            self.updatePoints(frameStartTime, frameEndTime);
        });
        this._peaks.on('points.remove', function (points) {
            points.forEach(function (point) {
                self._removePoint(point);
            });
            self._layer.draw();
        });
        this._peaks.on('points.remove_all', function () {
            self._layer.removeChildren();
            self._pointGroups = {};
            self._layer.draw();
        });
        this._peaks.on('points.dragged', function (point) {
            self._updatePoint(point);
            self._layer.draw();
        });
    };
    PointsLayer.prototype._createPointGroup = function (point) {
        var pointGroup = new Konva.Group();
        pointGroup.point = point;
        var editable = this._allowEditing && point.editable;
        pointGroup.marker = this._peaks.options.createPointMarker({
            draggable: editable,
            showLabel: this._showLabels,
            handleColor: point.color ? point.color : this._peaks.options.pointMarkerColor,
            height: this._view.height,
            pointGroup: pointGroup,
            point: point,
            layer: this._layer,
            onDrag: editable ? this._onPointHandleDrag.bind(this) : null,
            onDblClick: this._onPointHandleDblClick.bind(this),
            onDragEnd: editable ? this._peaks.options.pointDragEndHandler : null,
            onMouseEnter: this._onPointHandleMouseEnter.bind(this),
            onMouseLeave: this._onPointHandleMouseLeave.bind(this)
        });
        pointGroup.add(pointGroup.marker);
        return pointGroup;
    };
    PointsLayer.prototype._addPointGroup = function (point) {
        var pointGroup = this._createPointGroup(point);
        this._pointGroups[point.id] = pointGroup;
        this._layer.add(pointGroup);
        return pointGroup;
    };
    PointsLayer.prototype._onPointHandleDrag = function (pointGroup, point) {
        var markerX = pointGroup.marker.getX();
        if (markerX > 0 && markerX < this._view.width) {
            var offset = this._view.frameOffset + markerX + pointGroup.marker.getWidth();
            point.time = this._view.pixelsToTime(offset);
        }
        this._peaks.emit('points.dragged', point);
    };
    PointsLayer.prototype._onPointHandleMouseEnter = function (point) {
        this._peaks.emit('points.mouseenter', point);
    };
    PointsLayer.prototype._onPointHandleMouseLeave = function (point) {
        this._peaks.emit('points.mouseleave', point);
    };
    PointsLayer.prototype._onPointHandleDblClick = function (point) {
        this._peaks.emit('points.dblclick', point);
    };
    PointsLayer.prototype.updatePoints = function (startTime, endTime) {
        var points = this._peaks.points.find(startTime, endTime);
        var count = points.length;
        points.forEach(this._updatePoint.bind(this));
        count += this._removeInvisiblePoints(startTime, endTime);
        if (count > 0) {
            this._layer.draw();
        }
    };
    PointsLayer.prototype._updatePoint = function (point) {
        var pointGroup = this._findOrAddPointGroup(point);
        var timestampOffset = this._view.timeToPixels(point.time);
        var startPixel = timestampOffset - this._view.frameOffset;
        if (pointGroup.marker) {
            pointGroup.marker.setX(startPixel);
            if (pointGroup.marker.time) {
                pointGroup.marker.time.setText(Utils.formatTime(point.time, false));
            }
        }
    };
    PointsLayer.prototype._findOrAddPointGroup = function (point) {
        var pointGroup = this._pointGroups[point.id];
        if (!pointGroup) {
            pointGroup = this._addPointGroup(point);
        }
        return pointGroup;
    };
    PointsLayer.prototype._removeInvisiblePoints = function (startTime, endTime) {
        var count = 0;
        for (var pointId in this._pointGroups) {
            if (this._pointGroups.hasOwnProperty(pointId)) {
                var point = this._pointGroups[pointId].point;
                if (!point.isVisible(startTime, endTime)) {
                    this._removePoint(point);
                    count++;
                }
            }
        }
        return count;
    };
    PointsLayer.prototype._removePoint = function (point) {
        var pointGroup = this._pointGroups[point.id];
        if (pointGroup) {
            pointGroup.destroyChildren();
            pointGroup.destroy();
            delete this._pointGroups[point.id];
        }
    };
    PointsLayer.prototype.setVisible = function (visible) {
        this._layer.setVisible(visible);
    };
    return PointsLayer;
}(require('peaks/waveform/waveform.utils'), require('konva'));